import axios from 'axios';
import envService from "@/services/env.service";
import {logger} from "@/services/logger.service";
import userService from "@/services/user.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/billing';
const SESSION_PROFILE_ID = 'profileId';
const SESSION_BILLING_PROFILE_PAGE = 'billingProfilePage';

export default {
    getBillingProfiles(page, size, sort) {
        const params = {
            'page': page,
            'size': size,
            'sort': sort
        }
        return axios.get(BASE_URL + "/profile", {params: params});
    },
    getBillingProfile(profileId) {
        return axios.get(BASE_URL + '/profile/' + profileId);
    },
    getBillingProfileByWebId(webId) {
            return axios.get(BASE_URL + '/profile/webid/' + webId )
    },
    setBillingProfileIdToSession(profileId) {
        logger.debug("profileId=" + profileId);
        sessionStorage.setItem(SESSION_PROFILE_ID, profileId);
    },
    getBillingProfileIdFromSession() {
        return sessionStorage.getItem(SESSION_PROFILE_ID);
    },

    setBillingProfilePage(page) {
        sessionStorage.setItem(SESSION_BILLING_PROFILE_PAGE, page);
    },
    getBillingProfilePage() {
        var page = sessionStorage.getItem(SESSION_BILLING_PROFILE_PAGE);
        if (page == null)
            return 1
        else
            return page
    },
    updateBillingProfile(profileId, customerBillingReference, scn, backendContractId, company, zefix, firstName, lastName, birthday, billEmail, department, street, zip, city, country, billLanguage, contactPersonFirstName, contactPersonLastName, contactPersonEmail, contactPersonPhoneNumber, priceSwisscom, priceNational, priceInterNational, comment) {
        return axios.put(BASE_URL + "/profile/" + profileId,
            {
                "customerBillingReference": customerBillingReference,
                "scn": scn,
                "backendContractId": backendContractId,
                "company": company,
                "zefix": zefix,
                "department": department,
                "firstName": firstName,
                "lastName": lastName,
                "birthday": birthday,
                "street": street,
                "zip": zip,
                "city": city,
                "country": country,
                "billEmail": billEmail,
                "billLanguage": billLanguage,
                "contactPersonFirstName": contactPersonFirstName,
                "contactPersonLastName": contactPersonLastName,
                "contactPersonEmail": contactPersonEmail,
                "contactPersonPhoneNumber": contactPersonPhoneNumber,
                "priceSwisscom": priceSwisscom,
                "priceNational": priceNational,
                "priceInternational": priceInterNational,
                "comment": comment,
            })
    },
    createBillingProfileByAdmin(customerBillingReference, scn, backendContractId, company, zefix, firstName, lastName, birthday, billEmail, department, street, zip, city, country, billLanguage, contactPersonFirstName, contactPersonLastName, contactPersonEmail, contactPersonPhoneNumber, priceSwisscom, priceNational, priceInterNational, comment) {
        return axios.post(BASE_URL + "/profile",
            {
                "customerBillingReference": customerBillingReference,
                "scn": scn,
                "backendContractId": backendContractId,
                "company": company,
                "zefix": zefix,
                "department": department,
                "firstName": firstName,
                "lastName": lastName,
                "birthday": birthday,
                "street": street,
                "zip": zip,
                "city": city,
                "country": country,
                "billEmail": billEmail,
                "billLanguage": billLanguage,
                "contactPersonFirstName": contactPersonFirstName,
                "contactPersonLastName": contactPersonLastName,
                "contactPersonEmail": contactPersonEmail,
                "contactPersonPhoneNumber": contactPersonPhoneNumber,
                "priceSwisscom": priceSwisscom,
                "priceNational": priceNational,
                "priceInternational": priceInterNational,
                "comment": comment,
            })
    },
    createBillingProfileByCustomer(customerEmail, company, zefix, firstName, lastName, birthday, billEmail, department, street, zip, city, country, billLanguage, contactPersonFirstName, contactPersonLastName, contactPersonEmail, contactPersonPhoneNumber, comment) {
        return axios.post(BASE_URL + "/profile/" + customerEmail,
            {
                "customerBillingReference": customerEmail,
                "company": company,
                "zefix": zefix,
                "department": department,
                "firstName": firstName,
                "lastName": lastName,
                "birthday": birthday,
                "street": street,
                "zip": zip,
                "city": city,
                "country": country,
                "billEmail": billEmail,
                "billLanguage": billLanguage,
                "contactPersonFirstName": contactPersonFirstName,
                "contactPersonLastName": contactPersonLastName,
                "contactPersonEmail": contactPersonEmail,
                "contactPersonPhoneNumber": contactPersonPhoneNumber,
                "comment": comment,
            }, {
                headers: {
                    'X-User-Email': userService.getViewUserEmail()
                }
            })
    }
}
